import axios from 'axios';
import constants from '../../../../config/config';

export const newsletterSignup = async (data) => {
  const endpoint = 'v1/newsLetterSignup/create';
  try {
    const response = await axios.post(
      `${constants.endPointUrl[constants.ENVIRONMENT]}${endpoint}`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
